<template>
  <div>
    <el-form :model="query" ref="queryForm" :inline="true">
      <el-form-item label="预约类型：">
        <el-select v-model="query.type" placeholder="请选择" clearable size="small">
          <el-option label="线上服务" :value="20"></el-option>
          <el-option label="线下服务" :value="10"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select v-model="query.status" placeholder="请选择" clearable size="small">
          <el-option label="待排期" :value="10"></el-option>
          <el-option label="待服务" :value="20"></el-option>
          <el-option label="待评论" :value="30"></el-option>
          <el-option label="已完成" :value="40"></el-option>
          <el-option label="已取消" :value="50"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="提交预约时间：">
        <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleDownload" size="mini">导出</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import technicianServiceOrderApi from '@/api/technical/technicianServiceOrder'
export default {
  props: ['isIntegral'],
  data() {
    return {
      dateTime: [],
      list: [],
      total: 0,
      listLoading: true,
      query: {
        type: null,
        status:null
      },
      topicClassOptions: [],
    }
  },
  created() {
  },
  methods: {
    handleDownload() {
      this.query.createdTimeStart = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.createdTimeEnd = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined

      return this.$common.confirm('是否确认导出')
        .then(() => technicianServiceOrderApi.exportExcel(this.query)).then((res) => {
          if (res.code === '0') {
            setTimeout(() => {
              this.$emit('created')
            }, 500)

          }
        })
    },

  }

}
</script>

<style>
</style>
